import { useState } from 'react';
import img1 from '../assets/img/blog/blog-post-1.jpg';
import img2 from '../assets/img/blog/blog-post-2.jpg';

const AllBlogData = () => {
  const blogsData = [
    {
      id: 1,
      img: img1,
      title: 'Winning Team in Junik, Kosovo',
      commentor: 'Qaush ',
      date: '2022',
      tag: `project, business, economy, design`,
      description1:
        "I'm thrilled to share that I recently completed an exciting project with the Junik municipality of Kosovo. The initiative focused on boosting local tourism and economic growth by developing a web application for guesthouses, allowing tourists to book their accommodations online.",
      description2: "Empowering Junik's Tourism with Digital Innovation ",
      description3:
        'This project was a collaborative effort involving four talented programmers. My role was to design the website and create a comprehensive digital map highlighting the beautiful mountains and the charming town of Junik.',
      description4:
        'By making it easier for tourists to find and book guesthouses, we aim to increase tourism flow, support local businesses, and contribute to the economic prosperity of the region. I am proud to have been a part of this transformative project and look forward to seeing the positive impact it will have on Junik.',
    },
    // {
    //   id: 2,
    //   img: img2,
    //   title: 'Winning Team at Pitching Competition',
    //   commentor: 'Qaush ',
    //   date: '2023',
    //   tag: `wordpress, business, economy, design`,
    //   description1:
    //     'Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   description2:
    //     'If you’ve been waiting for an invitation, this calligraphy is it. Commissioned by Notebook hand-lettered design for a poster. Quote is Notebook Building 8 VP’s Regina Dugan—and mine. ',
    //   description3:
    //     'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
    //   description4:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    // },
  ];

  const [singleData, setSingleData] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const handleBlogsData = (id) => {
    const find = blogsData.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  return {
    singleData,
    isOpen,
    setIsOpen,
    blogsData,
    handleBlogsData,
  };
};

export default AllBlogData;
